import { CheckCheck, Home } from "lucide-react";
import { cn } from "@/utils/common.utils";
import { NEW_DEAL_STEPS, NEW_DEAL_STEP_HINTS } from "@/constant/deals.constant";

interface NewDealSidebarProps {
  step: number;
}

export default function NewDealSidebar({ step }: NewDealSidebarProps) {
  return (
    <aside className="relative hidden min-h-0 flex-col overflow-hidden bg-dash-wizardBg px-8 py-8 text-white md:flex">
      <div className="flex items-center gap-3">
        <span className="flex size-9 items-center justify-center rounded-xl bg-dash-wizardBrandIcon"><Home className="size-4 fill-white stroke-white" /></span>
        <div><p className="text-sm font-semibold">Stoop</p><p className="text-[10px] uppercase tracking-[0.18em] text-dash-wizardMuted/65">New deal</p></div>
      </div>

      <ol className="relative mt-8 flex flex-col gap-14 before:absolute before:bottom-[30px] before:left-[30px] before:top-[30px] before:w-px before:bg-dash-wizardLine">
        {NEW_DEAL_STEPS.map((item, index) => {
          const number = index + 1;
          const active = number === step;
          const complete = number < step;
          const Icon = item.icon;

          return (
            <li key={item.title} className={cn("relative flex items-center gap-3 rounded-xl px-3 py-3 transition-colors", (active || complete) && "bg-dash-wizardStep")}>
              <span className={cn("relative z-10 flex size-9 shrink-0 items-center justify-center rounded-full border-2", complete ? "border-dash-wizardCompleteRing bg-dash-wizardComplete" : active ? "border-white bg-dash-wizardIcon" : "border-dash-wizardLine bg-dash-wizardBg")}>
                {complete ? <CheckCheck className="size-4" /> : <Icon className={cn("size-4", !active && !complete && "opacity-30")} />}
              </span>
              <div className={cn(!active && !complete && "opacity-30")}><p className="text-sm font-semibold">{item.title}</p><p className="mt-0.5 text-[11px] text-dash-wizardMuted">{item.description}</p></div>
            </li>
          );
        })}
      </ol>

      <div className="mt-auto">
        <div className="flex items-center justify-between text-[11px] text-white/65"><span>Progress</span><span>{step}/3</span></div>
        <div className="mt-2 h-1 overflow-hidden rounded-full bg-white/10">
          <div className="h-full rounded-full bg-dash-lime transition-[width] duration-300" style={{ width: `${(step / 3) * 100}%` }} />
        </div>
        <div className="mt-4 rounded-2xl bg-white/[0.07] p-4">
          <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-dash-lime">Step hint</p>
          <p className="mt-2 text-xs leading-5 text-white/50">{NEW_DEAL_STEP_HINTS[step - 1]}</p>
        </div>
      </div>
    </aside>
  );
}
